export const ProjectStatusTypes = [
  "未着工",
  "施工前",
  "施工中",
  "施工終了",
  "保留"
] as const;

export type ProjectStatus = typeof ProjectStatusTypes[number];

export const ProjectStatusCode: Record<ProjectStatus, number> = {
  未着工: 5,
  施工前: 1,
  施工中: 2,
  施工終了: 4,
  保留: 3
};

export const ProjectStatusType: Record<string, ProjectStatus> = Object.entries(
  ProjectStatusCode
).reduce((o, [k, v]) => {
  o[v] = k;
  return o;
}, Object.create(null));

/**
 * 現場のステータスに対応する数値をステータスに変換する
 */
export function getProjectStatus(statusCode: string): ProjectStatus {
  const status = ProjectStatusType[statusCode];
  if (status) {
    return status;
  }
  throw new Error("invalid status code");
}

/**
 * 現場のステータスに対応する数値を得る
 */
export function getProjectStatusCode(status: ProjectStatus): number {
  const code = ProjectStatusCode[status];
  if (code) {
    return code;
  }
  throw new Error("invalid status");
}

/**
 * 文字列が現場のステータスかどうか
 */
export function isProjectStatus(status: string): status is ProjectStatus {
  return ProjectStatusTypes.includes(status as ProjectStatus);
}
